import { render } from "./WarningAlart.vue?vue&type=template&id=cb0984a4&scoped=true"
import script from "./WarningAlart.vue?vue&type=script&lang=js"
export * from "./WarningAlart.vue?vue&type=script&lang=js"

import "./WarningAlart.vue?vue&type=style&index=0&id=cb0984a4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-cb0984a4"

export default script